<script>
	import InfoPage from './InfoPage.svelte';
	import InfoSection from './InfoSection.svelte';
	import { Icon } from '../feathericons.js';

</script>

<InfoPage Title="Shepreth">

<svelte:fragment slot="blurb">
<InfoSection src="pics/shepreth.jpg" alt="Shepreth">
<p>A small village on the train-line to Cambridgeshire.</p>
<p><a href="https://sheprethparishcouncil.gov.uk" target="new">{@html Icon("external-link","small")} Shepreth website</a></p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="playgrounds">
<InfoSection id="Shepreth_Playground" Title="Shepreth Playground" src="pics/shepreth-park.jpg" alt="Shepreth Playground">
<p>This playground is hidden behind the village hall and features a great selection of equipment including a baby and parent swing. It is often very quiet and has parking right next to the playground</p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="attractions">
<InfoSection id="Wildlife_Park" Title="Shepreth Wildlife Park" src="pics/shepreth-wild.jpg" alt="Shepreth Wildlife Park">
<p>Shepreth has a small wildlife park with various animals and activities including keeper talks and VIP experiences where you can see the animals up close.</p>
<p><a href="https://sheprethwildlifepark.co.uk/" target="new">{@html Icon("external-link","small")} Website</a></p>
</InfoSection>

</svelte:fragment>
</InfoPage>
